'use strict';

angular.module('servicesController', [])

.controller('ServicesController', ['appInfo', '$scope', '$rootScope', '$log', '$location', '$window','SellerService', 'CommonService',
    function (appInfo, $scope, $rootScope, $log, $location, $window, SellerService, CommonService) {    
    
    $rootScope.header.style = "collapse";
    $rootScope.header.show = false;
    $scope.page = 'services';

    var currentUser = $rootScope.currentUser;

   
    $scope.services = [];
    var init = function() {
        if(typeof $rootScope.services !=='undefined'  && $rootScope.services.length){
            $scope.services = $rootScope.services;
        }
        else{
            loadServices();
        }
    }

    var loadServices = function() {
        $rootScope.loading = true;   
        SellerService.getServices($rootScope.currentListing.propertyRef)
        .then(function(data){
            $scope.services = data;
            $rootScope.services = data;
            $rootScope.loading = false;   
        })
        .catch(function(err){
            console.log(err);
        })
        .finally(function(data){
            $rootScope.loading = false;    
        });
    }

    init();

}]);